import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { closeBtn, dialogActions, dialogTitle, paperProps, title ,secondaryText} from './AliasAddModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import CustomInput from 'app/components/CustomInput';
import OTP from './OTP';

interface Props {
    open: boolean;
    close: Dispatch<SetStateAction<boolean>>;
    value: string;
    inputTitle: string;
    handleSubmit?:() => void;
    type?: 'email' | 'mobile';
    accountsModal: boolean;
    setAccountsModal: (prop: boolean) => void;
}

const AliasAddModal = (props: Props) => {
    const { open, close, value, inputTitle,handleSubmit,type,accountsModal,setAccountsModal } = props;
    const [successModal, setSuccessModal] = useState(false);
    const [unSuccessModal, setUnSuccessModal] = useState(false);
    const [otpShow, setOtpShow] = useState(false)
    const [otp, setOtp] = useState('')

    return (
        <>
            <Dialog
                open={open}
                PaperProps={{
                    sx: paperProps,
                }}
                onClose={() => {close(false);setOtp('');setOtpShow(false);}}
            >
                <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
                    <Box sx={{display: 'flex',flexDirection: 'column',gap: '12px'}}>
                        <Typography sx={title}>Alias əlavə et</Typography>
                        <Typography sx={secondaryText}>{type === 'mobile' ? 'Qeyd etdiyiniz əlaqə nömrəsinə SMS vasitəsilə yoxlama kodu göndəriləcək' : 'Qeyd etdiyiniz elektron poçta təsdiqləmə linki göndəriləcək'}</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ pl: '44px' }}>
                    {!otpShow ? <CustomInput value={value} title={type === 'mobile' ? 'Mobil nömrə' : 'Elektron poçt'} placeholder={type === 'mobile' ? 'Mobile number' : 'Elektron poçt'}/>  : <OTP setModalOtp={setOtp}/>}
                </DialogContent>
                <DialogActions sx={dialogActions}>
                    <Button
                        sx={{width: '100%'}}
                        onClick={() => {
                            if(type === 'mobile') {
                                setOtpShow(true);
                                if(otpShow) {
                                    handleSubmit();
                                    close(false);
                                    setSuccessModal(true);
                                    setOtpShow(false);
                                }
                            }
                            else {
                                close(false);
                                setSuccessModal(true);
                            }

                        }}
                        disabled={otpShow && otp.length !== 6}
                    >
                        Davam et
                    </Button>
                    <Button

                        color={'secondary'}
                        variant={'outlined'}
                        sx={{ ml: '0 !important',width: '100%'}}
                        onClick={() => {
                            close(false);
                            setOtpShow(false);
                            setOtp('')
                            // setUnSuccessModal(true);

                        }}
                    >
                        İmtina
                    </Button>
                </DialogActions>
            </Dialog>
            <SuccessModal open={successModal} close={setSuccessModal} successText={'Sorğunuz uğurla göndərildi!'} />
            <SuccessModal unsuccess={true} open={unSuccessModal} close={setUnSuccessModal} successText={'Sorğunun göndərilməsində xəta baş verdi!'} />
        </>
    );
};

export default AliasAddModal;
